import { useEffect } from "react";
import useSolrContext from "../store/use-solr-context";

/**
 * Syncs the current Solr filter state to the URL via replaceState.
 * Excludes preset filters (Drupal-driven) from the URL.
 * Reads are handled separately by parseUrlState() before the first render.
 */
const useSolrUrlSync = () => {
  const { currentFilters, currentSorting, searchQueryString, config } =
    useSolrContext();

  const presetFilterIds = config.presetFilters?.map((f) => f.field) ?? [];

  useEffect(() => {
    if (typeof window === "undefined") return;

    const params = new URLSearchParams();

    if (searchQueryString) {
      params.set("q", searchQueryString);
    }

    if (currentFilters) {
      Object.entries(currentFilters).forEach(([id, values]) => {
        if (!presetFilterIds.includes(id) && values?.length) {
          params.set(`f[${id}]`, values.join(","));
        }
      });
    }

    if (currentSorting) {
      params.set("sort", currentSorting);
    }

    const search = params.toString();
    const url = search
      ? `${window.location.pathname}?${search}`
      : window.location.pathname;

    window.history.replaceState(null, "", url);
  }, [currentFilters, currentSorting, searchQueryString]);
};

export default useSolrUrlSync;
